/* VIP rewards-trigger (rebuilt 2026-08-13, self-contained — no theme pubsub dependency).
   Keeps the hidden $0 "VIP" product (variant 49521085907172) in the cart whenever any
   real product is in the cart; removes it when it would be the only item. The item is
   visually hidden via CSS + the 'cart-hidden' product tag (counts). */
(function () {
  var VIP_ID = 49521085907172;
  var busy = false;

  function refreshCartUI() {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: {}, sections: ['cart-drawer', 'cart-icon-bubble'] })
    }).then(function (r) { return r.json(); }).then(function (cartData) {
      // silent sync only: update headings/counts from fresh section HTML.
      // (Never call drawer.renderContents() here — it force-OPENS the drawer.)
      var sections = cartData && cartData.sections;
      if (sections && sections['cart-drawer']) {
        var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
        ['.drawer__heading', '.cart-drawer__count-bubble'].forEach(function (sel) {
          var fresh = doc.querySelector(sel);
          var cur = document.querySelector(sel);
          if (fresh && cur) cur.innerHTML = fresh.innerHTML;
        });
      }
      if (sections && sections['cart-icon-bubble']) {
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble) bubble.innerHTML = sections['cart-icon-bubble'];
      }
    }).catch(function () {});
  }

  function setVipQty(q) {
    var updates = {};
    updates[VIP_ID] = q;
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    });
  }

  async function reconcile() {
    if (busy) return;
    busy = true;
    try {
      var cart = await (await fetch('/cart.js')).json();
      var vip = null;
      var others = 0;
      var prot = null;
      cart.items.forEach(function (i) {
        if (i.variant_id === VIP_ID) vip = i;
        else if (i.variant_id === 49657773228260) prot = i;
        else others++;
      });
      if (prot) {
        // retired Package Protection product — purge leftover cart items (2026-08-21)
        var pu = {};
        pu[49657773228260] = 0;
        await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: pu }) });
        await refreshCartUI();
      }
      if (others > 0 && !vip) {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: VIP_ID, quantity: 1 }] })
        });
        await refreshCartUI();
      } else if (others > 0 && vip && vip.quantity !== 1) {
        await setVipQty(1);
        await refreshCartUI();
      } else if (others === 0 && vip) {
        await setVipQty(0);
        if (location.pathname.indexOf('/cart') === 0) location.reload();
        else await refreshCartUI();
      } else {
        // no change needed — still re-sync drawer/count UI from server truth
        await refreshCartUI();
      }
    } catch (e) {}
    busy = false;
  }

  // watch every cart mutation the storefront makes (fetch)
  var origFetch = window.fetch;
  window.fetch = function () {
    var u = arguments[0];
    u = (typeof u === 'string') ? u : ((u && u.url) || '');
    var p = origFetch.apply(this, arguments);
    if (!busy && /\/cart\/(add|change|update|clear)/.test(u)) {
      p.then(function (res) { if (res && res.ok) setTimeout(reconcile, 200); }, function () {});
    }
    return p;
  };

  // ...and via XHR (jQuery-based sections)
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__ccCartMut = /\/cart\/(add|change|update|clear)/.test(url || '');
    return origOpen.apply(this, arguments);
  };
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (this.__ccCartMut && !busy) {
      this.addEventListener('loadend', function () {
        if (this.status >= 200 && this.status < 300) setTimeout(reconcile, 200);
      });
    }
    return origSend.apply(this, arguments);
  };

  // reconcile once per page load too (covers stale states)
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(reconcile, 500); });
  else setTimeout(reconcile, 500);
})();
